import { render } from "./QualityInspection.vue?vue&type=template&id=5dc6c848&scoped=true"
import script from "./QualityInspection.vue?vue&type=script&lang=js"
export * from "./QualityInspection.vue?vue&type=script&lang=js"

import "./QualityInspection.vue?vue&type=style&index=0&id=5dc6c848&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5dc6c848"

export default script